<!-- 共赢车辆利润分成表 -->
<template>
  <div class="mod-user">
    <div class="searchBox">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="车牌号">
          <el-input v-model="dataForm.vehiclePlate" placeholder="支持模糊查询" clearable></el-input>
        </el-form-item>
        <el-form-item label="月份" prop="takeGoodsDate">
          <el-date-picker
            v-model="dataForm.takeGoodsDate"
            type="monthrange"
            align="right"
            unlink-panels
            value-format="yyyy-MM"
            :clearable="false"
            range-separator="-"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" type="primary">查询</el-button>
          <el-button @click="downLoad()" type="success">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table :data="dataList"
                :row-class-name="tableRowClassName"
                @row-click="rowClick"
                :row-style="selectedHighlight"
                show-summary
                :height="this.tableHeight"
                border size="small"
                v-loading="dataListLoading"
                style="width: 100%;">
        <el-table-column type="index" label="序号" width="40" fixed="left">
        </el-table-column>
        <el-table-column prop="vehiclePlate" label="车牌号" width="70" :show-overflow-tooltip="true" fixed="left">
        </el-table-column>
        <el-table-column prop="yearMonth" label="年月" width="55" :show-overflow-tooltip="true" fixed="left">
        </el-table-column>
        <el-table-column prop="orderNum" label="订单数" :formatter="getNumValue" :show-overflow-tooltip="true" fixed="left" width="45">
        </el-table-column>
        <el-table-column prop="totalReceivable"  :formatter="getNumValue" label="总应收" :show-overflow-tooltip="true" fixed="left" width="70">
        </el-table-column>
        <el-table-column label="成本支付(司机代支部分)" align="center">
          <el-table-column prop="weighFee" label="过磅费" :formatter="getNumValue" :show-overflow-tooltip="true" width="50">
          </el-table-column>
          <el-table-column prop="loadFee" label="装卸费" :formatter="getNumValue" :show-overflow-tooltip="true" width="50">
          </el-table-column>
          <el-table-column prop="entranceFee" label="入仓报关费" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
          <el-table-column prop="parkingFee" label="停车费" :formatter="getNumValue" :show-overflow-tooltip="true" width="50">
          </el-table-column>
          <el-table-column prop="highFee" label="高速费" :formatter="getNumValue" :show-overflow-tooltip="true" width="50">
          </el-table-column>
          <el-table-column prop="printFee" label="打印费" :formatter="getNumValue" :show-overflow-tooltip="true" width="50">
          </el-table-column>
          <el-table-column prop="maintainFee" label="维修费" :formatter="getNumValue" :show-overflow-tooltip="true" width="50">
          </el-table-column>
          <el-table-column prop="otherFee" label="其他费用" :formatter="getNumValue" :show-overflow-tooltip="true" width="60">
          </el-table-column>
          <el-table-column prop="refuelFee" label="现金加油费" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
          <el-table-column prop="passingFee" label="现金过路费" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
        </el-table-column>
        <el-table-column label="成本支付(平台代支部分)" align="center">
          <el-table-column prop="refuelCardFee" label="油卡加油费" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
          <el-table-column prop="passingCardFee" label="粤通卡过路费" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
          <el-table-column prop="allWinParkingFee" label="车辆停车费" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
          <el-table-column prop="createCardFee" label="车辆办证费" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
          <el-table-column prop="insureMoney" label="车辆保险费" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
          <el-table-column prop="repairMoney" label="车辆维修费" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
          <el-table-column prop="lossMoney" label="事故损失费" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
          <el-table-column prop="affiliationFee" label="车辆挂靠费" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
          <el-table-column prop="other1Fee" label="其他费用1" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
          <el-table-column prop="other2Fee" label="其他费用2" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
          </el-table-column>
        </el-table-column>
        <el-table-column prop="netProfit" label="车辆纯利润" :formatter="getNumValue" :show-overflow-tooltip="true" width="80">
        </el-table-column>
        <el-table-column prop="allWinVehicleProfitFee" label="共赢车分成" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
        </el-table-column>
        <el-table-column prop="platformShareFee" label="平台分成" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
        </el-table-column>
        <el-table-column prop="driverBorrowing" label="司机借支" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
        </el-table-column>
        <el-table-column prop="driverPrepayment" label="司机月代垫" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
        </el-table-column>
        <el-table-column prop="platformPrepayment" label="平台月代垫" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
        </el-table-column>
        <el-table-column prop="totalAllWinVehicleProfitFee" label="总应付司机" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
        </el-table-column>
        <el-table-column prop="totalPlatformShareFee" label="总应付平台" :formatter="getNumValue" :show-overflow-tooltip="true" width="70">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick (picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dataForm: {
        vehiclePlate: null,
        takeGoodsDate: null
      },
      showTotal: false,
      dataList: [],
      pageIndex: 1,
      getIndex: -1,
      pageSize: 20,
      tableHeight: '65vh',
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      detailVisible: false
    }
  },
  created () {
    let now = new Date()
    let start = new Date(now.getFullYear(), 0, 1)
    this.dataForm.takeGoodsDate = [this.dateFormatter(start, 'yyyy-MM'), this.dateFormatter(now, 'yyyy-MM')]
    this.getDataList()
  },
  computed: {
    dictTypeMap: {
      get () { return this.$store.state.common.dictTypeMap }
    }
  },
  methods: {
    /**
     * 点击表格变色start
     */
    selectedHighlight ({ row, rowIndex }) {
      if ((this.getIndex) === rowIndex ) {
        return {
          'background-color': 'rgb(250, 195, 100)'
        }
      }
    },
    // 如果为已取消时，该行置灰
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex
      if (row.status === 12) {
        return 'cancel-row'
      }
      return ''
    },
    rowClick (row) {
      this.getIndex = row.index
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      let takeGoodsTime = this.dataForm.takeGoodsDate
      let timeParam = {}
      if (takeGoodsTime && takeGoodsTime.length === 2) {
        timeParam.takeGoodsBeginDate = takeGoodsTime[0]
        timeParam.takeGoodsEndDate = takeGoodsTime[1]
      }
      this.$http({
        url: this.$http.adornUrl('/costSummary/allWinVehicleProfitList'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'limit': this.pageSize,
          'vehiclePlate': this.dataForm.vehiclePlate,
          'beginDate': timeParam.takeGoodsBeginDate,
          'endDate': timeParam.takeGoodsEndDate
        })
      }).then(({ data }) => {
        if (data) {
          this.dataList = data.list
          this.totalPage = data.total
          // this.getAllSummaries(data.profitCount || {})
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        if (!this.showTotal) {
          // 解决elementUI table合计行初始页面不显示问题  this.height由父组件传递过来 this.theight未表格绑定的高度
          this.tableHeight = '67vh'
          this.showTotal = true
        }
        this.dataListLoading = false
      })
    },
    downLoad () {
      let takeGoodsTime = this.dataForm.takeGoodsDate
      let timeParam = {}
      if (takeGoodsTime && takeGoodsTime.length === 2) {
        timeParam.takeGoodsBeginDate = takeGoodsTime[0]
        timeParam.takeGoodsEndDate = takeGoodsTime[1]
      }
      this.$http({
        url: this.$http.adornUrl(`/costSummary/export/allWinVehicleProfit`),
        method: 'get',
        responseType: 'blob',
        params: this.$http.adornParams({
          'vehiclePlate': this.dataForm.vehiclePlate,
          'beginDate': timeParam.takeGoodsBeginDate,
          'endDate': timeParam.takeGoodsEndDate
        })
      }).then(({ data }) => {
        const blob = data
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = (e) => {
          const a = document.createElement('a')
          a.download = '车辆利润统计表.xls'
          a.href = e.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      })
    },
    getNumValue (row, cell, value) {
      return this.getValue(value)
    },
    getValue (value) {
      if (value === undefined || value === null) {
        return ''
      }
      if (value === 0) {
        return ''
      } else {
        return value
      }
    },
    getAllSummaries (profitCount) {
      // 合计参数，按顺序返回
      let param = ['合计', '', '',
        this.getValue(profitCount.vehicleProfitMonth),
        this.getValue(profitCount.freightFee),
        this.getValue(profitCount.payFreightFee),
        this.getValue(profitCount.refuelFee),
        this.getValue(profitCount.passingFee),
        this.getValue(profitCount.stayFee),
        this.getValue(profitCount.extraFee),
        this.getValue(profitCount.royaltyFee),
        this.getValue(profitCount.salesmanFee),
        this.getValue(profitCount.salesmanManagerFee),
        this.getValue(profitCount.serviceFee),
        this.getValue(profitCount.maintainFee),
        this.getValue(profitCount.taxesFee),
        this.getValue(profitCount.createCardFee),
        this.getValue(profitCount.insureMoney),
        this.getValue(profitCount.repairMoney),
        this.getValue(profitCount.lossMoney)
      ]
      // 创建列表行
      let tr = document.createElement('tr')
      // 删除上一条合计
      if (document.querySelector('.el-table__footer-wrapper table tbody').childElementCount === 2) {
        document.querySelector('.el-table__footer-wrapper table tbody').lastChild.remove()
      }
      // td赋值
      param.forEach((item, index) => {
        let td = document.createElement('td')
        td.innerHTML = item
        tr.appendChild(td)
      })
      // 添加合计
      document.querySelector('.el-table__footer-wrapper table tbody').appendChild(tr)
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    }
  }
}
</script>
<style lang="less">
  span.searchUpload {
    display: inline-block;
    margin-left: 10px;
  }
</style>
